module.exports = __webpack_public_path__ + "img/logo.bba4a064.png";